/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    preConfig: {
        noData: {
            description: "Aucune donnée présente pour le moment !",
            title: "Aucune donnée"
        },
        noResultInFilter: {
            description: "Aucune correspondance à votre recherche. Veuillez réinitialiser vos filtres.",
            title: "Aucun résultat"
        }
    }
};